import {QuestionTagType} from "@components/RefMan/Quiz/types";

const buildOption = (data: QuestionTagType) => {
        return {value: data.cod_tag, label: data.cod_tag,}
    }

export const getTagOption = (data: QuestionTagType[]) => {
    return data.map((qtt) => buildOption(qtt))
}
